import { useState } from "react";

const EmailPostForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    try {
      const response = await fetch("https://connect.mailerlite.com/api/subscribers", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_MAILERLITE_TOKEN}`
        },
        body: JSON.stringify({ email, groups: ["154591469376636219"] }),
      });

      if (response.ok) {
        setStatus("Success!");
      } else {
        setStatus("Failed to submit.");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("Error occurred.");
    }
  };

  return (
    <div className="flex items-center justify-center bg-gray-100 px-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-xl shadow-md w-full max-w-md space-y-4"
      >
        <input
          type="email"
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button
          type="submit"
          className="w-1/2 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition border-2 border-brown"
        >
          Submit
        </button>
        {status && (
          <p className="text-center text-sm text-gray-600">{status}</p>
        )}
      </form>
    </div>
  );
};

export default EmailPostForm;
